var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 -256 1792 1792",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)",
      verticalAlign: "-0.143em"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555 1079l78-141q-87-63-136-159t-49-203q0-121 61-225q-229 117-381 353q167 258 427 375zm389-759q0-20-14-34t-34-14q-125 0-214.5 89.5T592 576q0 20 14 34t34 14t34-14t14-34q0-86 61-147t147-61q20 0 34-14t14-34zm363-191q0 7-1 9q-106 189-316 567t-315 566l-49 89q-10 16-28 16q-12 0-134-70q-16-10-16-28q0-12 44-87q-143-65-263.5-173T20 773Q0 742 0 704t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16q5 0 18 6t31 15.5t33 18.5t31.5 18.5T1291 102q16 10 16 27zm37 447q0 139-79 253.5T1056 994l280-502q8 45 8 84zm448 128q0 35-20 69q-39 64-109 145q-150 172-347.5 267T896 1280l74-132q212-18 392.5-137T1664 704q-115-179-282-294l63-112q95 64 182.5 153T1772 635q20 34 20 69z",
    fill: "#626262"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -256,
    width: 1792,
    height: 1792,
    fill: "rgba(0, 0, 0, 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.6f45aa1ae183adce08a61ef2e1fa1779.svg";
export { ForwardRef as ReactComponent };